(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$scope', 'SoopkitchenUtils', 'Administration'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $scope, SoopkitchenUtils, Administration) {
        var vm = this;

        vm.authorities = ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.sort = sort;
        vm.userRegistrationEnabled = false;
        vm.enableRegistration = enableRegistration;
        vm.disableRegistration = disableRegistration;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query(
            onSuccess, onError);
            Administration.get({}, function(result) {
                    vm.userRegistrationEnabled = result.userRegistrationEnabled;
            });
        }

        function onSuccess(data) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            vm.users = SoopkitchenUtils.sort(vm.users, vm.predicate, !vm.ascending);
            $scope.$apply();
        }
        function enableRegistration () {
            Administration.update({userRegistrationEnabled: true}, function(result) {
                vm.userRegistrationEnabled = result.userRegistrationEnabled;
                $scope.$apply();
            });
        }
        function disableRegistration () {
            Administration.update({userRegistrationEnabled: false}, function(result) {
                vm.userRegistrationEnabled = result.userRegistrationEnabled;
                $scope.$apply();
            });
        }
    }
})();
